// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channel-item__channel-actions {
  display: flex;
  flex-direction: row;
  justify-self: flex-end;
}

.channel-item__channel-actions .btn {
  margin: 0 0.5rem;
}

.channel-item__btn-remove {
  background-color: #d22e37;
}

.channel-item__btn-restart {
    background-color: #d22e37;
}

.channel-item__channel-type {
    display: block;
    color: black;
    outline: none;
    padding: 0;
    margin: 0;
    margin-bottom: 0.9rem;
    border: none;
    border-bottom: 1px solid #9e9e9e;
    transition: box-shadow 0.3s, border 0.3s;
    height: auto;
    padding-bottom: 5px;
    line-height: 1.5;
    margin-top: 16px;
}

.channel-item__channel-type:focus {
  display: block;
  border: none;
  outline: none;
  border-bottom: 1px solid #26a69a;
  box-shadow: 0 1px 0 0 #26a69a;
}

.channel-item__enabled-cell {
  text-align: center;
}

[type="checkbox"]:checked
  + .channel-item__is-enabled.not-started:not(.lever):before {
  border-right: 2px solid red;
  border-bottom: 2px solid red;
}

.channel-item-cell {
  padding-right: 1.8rem;
}

.channel-item__operators {
  width: auto;
  padding: 0;
}

.channel-item {
  box-shadow: 0 2px 2px 0 #00000024, 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
  margin: 2rem 0;
  padding: 1rem;
  overflow: hidden;
}

.channel-item__operators-row {
  padding-bottom: 5px;
}

.channel-item-content {
    display: grid;
    grid-template-columns: 3fr 1.5fr 1.5fr 1fr 2fr;
    column-gap: 1.8rem;
    text-align: start;
}

.channel-item-id {
  left: 2rem;
  margin-top: -1.4rem;
  position: absolute;
  font-style: italic;
  font-size: small;
  color: #ccc;
}

.channel-item .is-invalid {
  border-bottom: 1px solid red !important;
}

.channel-item .is-invalid:focus{
  box-shadow: 0 1px 0 0 red !important;
}

.channel-item input[type="text"] {
    height: auto;
    padding-bottom: 5px; 
    line-height: 1.5; 
    margin-top: 16px;
}

.channel-item__enabled-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%; 
}

.channel-item__channel-actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center; 
}`, "",{"version":3,"sources":["webpack://./src/app/channel/channel-main/channel-list/channel-item/ChannelItem.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,UAAU;IACV,SAAS;IACT,qBAAqB;IACrB,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;gCAC8B;EAC9B,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,8CAA8C;IAC9C,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":[".channel-item__channel-actions {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-self: flex-end;\r\n}\r\n\r\n.channel-item__channel-actions .btn {\r\n  margin: 0 0.5rem;\r\n}\r\n\r\n.channel-item__btn-remove {\r\n  background-color: #d22e37;\r\n}\r\n\r\n.channel-item__btn-restart {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.channel-item__channel-type {\r\n    display: block;\r\n    color: black;\r\n    outline: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    margin-bottom: 0.9rem;\r\n    border: none;\r\n    border-bottom: 1px solid #9e9e9e;\r\n    transition: box-shadow 0.3s, border 0.3s;\r\n    height: auto;\r\n    padding-bottom: 5px;\r\n    line-height: 1.5;\r\n    margin-top: 16px;\r\n}\r\n\r\n.channel-item__channel-type:focus {\r\n  display: block;\r\n  border: none;\r\n  outline: none;\r\n  border-bottom: 1px solid #26a69a;\r\n  box-shadow: 0 1px 0 0 #26a69a;\r\n}\r\n\r\n.channel-item__enabled-cell {\r\n  text-align: center;\r\n}\r\n\r\n[type=\"checkbox\"]:checked\r\n  + .channel-item__is-enabled.not-started:not(.lever):before {\r\n  border-right: 2px solid red;\r\n  border-bottom: 2px solid red;\r\n}\r\n\r\n.channel-item-cell {\r\n  padding-right: 1.8rem;\r\n}\r\n\r\n.channel-item__operators {\r\n  width: auto;\r\n  padding: 0;\r\n}\r\n\r\n.channel-item {\r\n  box-shadow: 0 2px 2px 0 #00000024, 0 3px 1px -2px rgb(0 0 0 / 12%),\r\n    0 1px 5px 0 rgb(0 0 0 / 20%);\r\n  margin: 2rem 0;\r\n  padding: 1rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.channel-item__operators-row {\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.channel-item-content {\r\n    display: grid;\r\n    grid-template-columns: 3fr 1.5fr 1.5fr 1fr 2fr;\r\n    column-gap: 1.8rem;\r\n    text-align: start;\r\n}\r\n\r\n.channel-item-id {\r\n  left: 2rem;\r\n  margin-top: -1.4rem;\r\n  position: absolute;\r\n  font-style: italic;\r\n  font-size: small;\r\n  color: #ccc;\r\n}\r\n\r\n.channel-item .is-invalid {\r\n  border-bottom: 1px solid red !important;\r\n}\r\n\r\n.channel-item .is-invalid:focus{\r\n  box-shadow: 0 1px 0 0 red !important;\r\n}\r\n\r\n.channel-item input[type=\"text\"] {\r\n    height: auto;\r\n    padding-bottom: 5px; \r\n    line-height: 1.5; \r\n    margin-top: 16px;\r\n}\r\n\r\n.channel-item__enabled-cell {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%; \r\n}\r\n\r\n.channel-item__channel-actions {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n    align-items: center; \r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
